import apiClient from './client';
import type { Comment, CreateCommentRequest, UpdateCommentRequest, CommentPaginatedResponse } from '../types/comment';
import { API_ENDPOINTS } from '../config/api';

export const commentsApi = {
  /**
   * Get comments for a post with pagination
   * @param includeDeleted if true, includes deleted comments (for moderators)
   */
  getCommentsByPostId: async (postId: string, page: number = 0, size: number = 20, includeDeleted: boolean = false): Promise<CommentPaginatedResponse> => {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('size', size.toString());
    if (includeDeleted) {
      params.append('includeDeleted', 'true');
    }
    
    const url = `${API_ENDPOINTS.POST_COMMENTS(postId)}?${params.toString()}`;
    const response = await apiClient.get<CommentPaginatedResponse>(url);
    return response.data;
  },

  /**
   * Create a new comment
   */
  createComment: async (postId: string, data: CreateCommentRequest): Promise<Comment> => {
    const response = await apiClient.post<Comment>(API_ENDPOINTS.POST_COMMENTS(postId), data);
    return response.data;
  },

  /**
   * Update an existing comment
   */
  updateComment: async (id: string, data: UpdateCommentRequest): Promise<Comment> => {
    const response = await apiClient.put<Comment>(API_ENDPOINTS.COMMENT_BY_ID(id), data);
    return response.data;
  },

  /**
   * Delete a comment
   */
  deleteComment: async (id: string): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.COMMENT_BY_ID(id));
  },

  /**
   * Flag a comment as inappropriate. Comment is hidden from public list until a moderator reviews it.
   */
  flagComment: async (id: string, reason?: string): Promise<void> => {
    await apiClient.post(`${API_ENDPOINTS.COMMENT_BY_ID(id)}/flag`, reason != null ? { reason } : {});
  },
};

